import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

import { contactFormApi } from '../api/contactApi';
import useYupValidationResolver from './useYupValidationResolver';
import { getContactFormValidationSchema } from '../helpers/validationSchemaHelper';
import { CONTACT_FORM_DEFAULT_VALUES } from '../constants/login';
import { SET_IS_LOADING } from '../constants/actionTypes';
import useGeneral from './useGeneral';
import useTurnstile from './useTurnstile';

function useContact() {
  const resolver = useYupValidationResolver(getContactFormValidationSchema());
  const { register, handleSubmit, errors, reset } = useForm({ resolver, defaultValues: CONTACT_FORM_DEFAULT_VALUES });
  const { showToasts } = useGeneral();
  const dispatch = useDispatch();

  const [isChecked, setIsChecked] = useState(false);
  const { turnstileToken, ensureTurnstileToken, resetTurnstile, turnstileProps } = useTurnstile();

  async function submitContactForm(formData) {
    if (!isChecked) {
      return;
    }

    if (!ensureTurnstileToken()) {
      return;
    }

    dispatch({ type: SET_IS_LOADING, payload: true });

    try {
      const response = await contactFormApi({ ...formData, turnstile_token: turnstileToken });
      const { data } = response;

      toast.success(data.message);
      reset();
      resetTurnstile();
    } catch (error) {
      reset();
      showToasts(error);
      resetTurnstile();
    } finally {
      dispatch({ type: SET_IS_LOADING, payload: false });
    }
  }

  return { submitContactForm, register, handleSubmit, errors, reset, setIsChecked, isChecked, turnstileProps };
}

export default useContact;
